import React, {useState, useEffect} from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useInputState from '../hooks/forms/useInputState';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import ErrorMessage from '../elements/ErrorMessage';
import styles from '../styles/login/LoginForm.module.css';
import {FormValidator, ShowValidation } from '../utils/validation/FormValidator';
import {EmailField, PasswordFieldLogin} from '../utils/validation/auth/AuthValidators';
import {makeLogin, fetchProfile, connectionError, reset} from './userSlice';
import ReCAPTCHA from "react-google-recaptcha";

const LoginForm = (props) => {
    const {redirectUrl, openAccountLink} = props;
   
    const {email, setEmail, editTryLogin} = props;
    const dispatch = useDispatch();
    const [password, editPassword, resetPassword] = useInputState('');
    const [isLoading, editIsLoading] = useState(false);
    const [captcha, editCaptcha] = useState({
        captcha: false,
        isValid: false
    });
    let user = useSelector(state => state.user); 
    let loginError = useSelector(state => state.user.error);
    const router = useRouter();

    useEffect( ()=>{
        redirectToAccount();
    }, [user.hasProfile]);

    const redirectToAccount = () => {
        if (user.hasProfile && redirectUrl) {
            router.push(redirectUrl);
        } 
    }

    //load validation rules for fields
    const ValidationRules = {
        email: EmailField,
        password: PasswordFieldLogin
    };

    //blur validation
    function validateFieldOnBlur(e){
        const value = e.target.value;
        const id= e.target.id;
        const res = ValidationRules[id](value);
        ShowValidation(id, res);
    }

    async function handleLogin(e) {
        e.preventDefault();
        let validForm = FormValidator('loginForm', ValidationRules); 
      
        if (validForm && verifyCapcha()) {
            editIsLoading(true);
            try {
                const resultAction = await dispatch(
                    makeLogin({email: email, password: password, captcha: captcha.captcha})
                    );
                
                const response = unwrapResult(resultAction);
                
                if (response.status == true) {
                    checkUserProfile();
                } else {
                    editIsLoading(false);  
                }
            }
             catch(err) {
                editIsLoading(false);
                dispatch(connectionError('Ups, nu ne putem conecta. Te rugam sa incerci mai tarziu.'));
            }
        }
    }

    async function checkUserProfile() {
        try{
            if ((!user.isLoggedIn)  ) {
                const resultAction = await dispatch(fetchProfile());
                const response = unwrapResult(resultAction);
            }
        } catch(err) {
            dispatch(reset());
        }
    }

    const requestReset = () => {
        editTryLogin(false);
    }

    const verifyCapcha =  () => {
        if (user.showCaptcha && !captcha.captcha) {
            return false;
        }
        return true;
    }

    const errorMessage = loginError && <div className="mb-3">
                                            <ErrorMessage title="Autentificare nereușită" message={loginError} />
                                        </div>; 
  
    const spinner = isLoading &&  <><Spinner as="span" animation="grow" size="sm" role="status"
                                    aria-hidden="true" />
                            Te rugăm să aștepți...
                            </>;
    const btnDisabled = isLoading && 'disabled';
    const loginBtn =  <Button variant="secondary" type="submit" className="col-12" disabled={btnDisabled}  >
                        {spinner}
                    {!isLoading && 'Login'}
                </Button>;

    const recaptchaChange = (value) => {
        let newCaptcha = {...captcha, captcha: value, isValid: true};
        editCaptcha(newCaptcha);
    }

    const errorCaptcha = <div className="helper red">Trebuie sa bifezi acest camp</div>;

    const  requestCatpcha = <>
                                <ReCAPTCHA
                                    sitekey="6LfB6dktAAAAAI_blzzzR5fJJA6Ipt0ET7TWrYxj"
                                    onChange={recaptchaChange}
                                />
                                {captcha.isValid ? '' : errorCaptcha}
                            </>;
    
    return (
        <>
            {errorMessage}
            <Form onSubmit={ handleLogin } id="loginForm">
                <Form.Group controlId="email">
                    <Form.Label className={styles.login}>Email</Form.Label>
                    <Form.Control type="text" name="email" placeholder="Adresa de email" 
                        onChange={setEmail} 
                        onBlur={validateFieldOnBlur}
                        value={email} 
                        autoComplete="email"
                    />
                    <Form.Text className="helper" as="div">    
                    </Form.Text>
                </Form.Group>

                <Form.Group controlId="password">
                    <Form.Label className={styles.login}>Parolă</Form.Label>
                    <Form.Control type="password" name="password" placeholder="Parolă" 
                        onChange={editPassword} 
                        value={password} 
                        onBlur={validateFieldOnBlur}
                        autoComplete="current-password"
                        
                    />
                    <Form.Text className="helper" as="div">    
                    </Form.Text>
                </Form.Group>
                <div className={styles.recaptcha} id="recapctha">
                    { user.showCaptcha ? requestCatpcha : ''}
                </div>
                
                {loginBtn}
               
            </Form>
            <p className="mt-3 text-center mb-0">        
                <Button variant="link" onClick={requestReset} >Ai uitat parola?</Button>
            </p>
            {openAccountLink &&
             <>
                 <hr />
                 <p className="mt-3">
                     Nu ai încă un cont? <Link href="/creeaza-cont" title="Deschide cont">Deschide cont</Link> gratuit.
                 </p>
             </>
            }
        </>
    );
}

export default LoginForm;